import { NNBSP } from './constants';

export const formatAmountValue = (amount: string | number) => {
  amount = String(amount)
    .replace(/[^\d.]/g, '')
    .replaceAll(' ', '');
  if (/\.[0-9]{2}/g.test(amount)) {
    amount = parseFloat(amount).toFixed(2);
  } else if (/\.[0-9]{1}/g.test(amount)) {
    amount = parseFloat(amount).toFixed(1);
  }
  return amount.replace(/\B(?=(\d{3})+(?!\d))/g, NNBSP);
};
